import { useEffect, useState } from "react"

const mobileUserAgent = "Superwall/MobileClient"

const useUserAgent = () => {
  const [userAgent, setUserAgent] = useState<string | undefined>()

  useEffect(() => {
    if (typeof window !== "undefined") {
      setUserAgent(window.navigator.userAgent)
    }
  }, [])

  return { userAgent, isMobileClient: userAgent?.includes(mobileUserAgent) }
}

export default useUserAgent
